const i = (e, t) => !(e instanceof Date) || isNaN(e.getTime()) ? "" : new Intl.DateTimeFormat(
  "en-US",
  t || {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  }
).format(e);
export {
  i as f
};
